import { Modal } from 'antd'
import Router from 'next/router'
import { AiCreateArtworkModel } from '~/graphqls/types'
import { useStores } from './useStores'
import { useAuth } from './useAuth'
import { useValidateVip } from './useValidateVip'

export const useMjCreateValidation = () => {
  const { store } = useStores()
  const { isHighUser } = useAuth()
  const { vipModal } = useValidateVip()
  const showModal = ({
    content,
    confirmText,
    onConfirm,
  }: {
    content: string
    confirmText: string
    onConfirm: () => void
  }) => {
    Modal.confirm({
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: `hookModal dark`,
      content: (
        <div className="text-neutral-400 text-sm text-center">{content}</div>
      ),
      okText: confirmText,
      onOk: close => {
        onConfirm()
        close()
      },
    })
  }

  const validMjCreate = ({
    model,
    selectModel,
    isSuperType = false,
    isSameType,
    count = 4,
    onConfirm,
  }: {
    model?: AiCreateArtworkModel | null
    selectModel?: AiCreateArtworkModel | null
    isSuperType?: boolean // 是否超分
    isSameType: boolean // 是否同款
    onConfirm: () => void
    count?: number // 作画数量
  }) => {
    if (
      model !== AiCreateArtworkModel.MIDJOURNEY &&
      !(selectModel === AiCreateArtworkModel.MIDJOURNEY)
    ) {
      onConfirm()
      return
    }
    if (!!selectModel && selectModel !== AiCreateArtworkModel.MIDJOURNEY) {
      onConfirm()
      return
    }
    const freePointBalance =
      store.userinfo?.integralWalletBalance?.originCardBalance
    const cost = count * (isSuperType ? 3 : 2)

    if (!isHighUser) {
      // 非会员
      vipModal('此作品由VIP模型生成，仅限VIP会员专享使用')
    } else {
      // 会员
      if (isSameType) {
        // 同款：提示开销
        const tips = isSuperType
          ? '本高分辨率作品由MJ模型创作生成，同款将一键生成4张高分辨率作品。'
          : '本作品由MJ模型创作生成，同款将一键生成4张作品。'
        showModal({
          content: tips,
          confirmText: '确认同款',
          onConfirm,
        })
      } else {
        // ai创作：开始创作
        onConfirm()
      }
    }
  }

  return {
    validMjCreate,
  }
}
